export class BoundedSemaphore {
    constructor(upperBound) {
        this.upperBound = upperBound;
        this.current = 0;
        this.obtainersWaitingForSlot = [];
    }
    async waitOne() {
        return new Promise((resolve) => {
            const handleObtain = () => {
                this.current++;
                const releaser = () => {
                    this.current--;
                    const nextInQueue = this.obtainersWaitingForSlot.shift();
                    if (nextInQueue) {
                        nextInQueue();
                    }
                };
                resolve(releaser);
            };
            if (this.current >= this.upperBound) {
                this.obtainersWaitingForSlot.push(handleObtain);
            }
            else {
                handleObtain();
            }
        });
    }
}
